<template>
  <div class="flex min-h-screen flex-col">
    <!-- Header -->
    <div
      class="sticky top-0 z-10 flex h-12 items-center justify-between gap-3 bg-[--header-top-bg-color] px-6 shadow-md lg:px-12 lg:py-5 text-sm text-[--header-top-text-color] print:relative print:px-0 print:shadow-none"
    >
      <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12">
        <div class="flex flex-row w-full justify-between">
          <router-link to="/" replace>
            <VcImage :src="logoUrl" :alt="$context.storeName" class="h-6 print:h-12" lazy />
          </router-link>

          <div class="flex">
            <div class="flex items-center gap-x-1.5 text-neutral print:-me-px print:border print:px-2">
              <VcIcon size="xs" name="lock-closed" />

              <span class="hidden text-sm font-bold xs:inline print:inline">
                {{ $t("common.labels.secure_checkout") }}
              </span>
            </div>

            <Created />
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="relative flex grow flex-col">
      <slot />
    </div>

    <InnoFooter compact />
  </div>
</template>

<script setup lang="ts">
import { useWhiteLabeling } from "@/core/composables";
import InnoFooter from "@/shared/layout/components/footer/innovadis/inno-footer.vue";
import Created from "../../print/created.vue";

const { logoUrl } = useWhiteLabeling();
</script>
